module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate-choice-wrapper",
    class: _vm.wrapperClasses
  }, [(_vm.showDonateType) ? _c('product-donate-type', {
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.donateType),
      callback: function($$v) {
        _vm.donateType = $$v
      },
      expression: "donateType"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row px-2 justify-content-center mb-2"
  }, [_vm._l((_vm.cleanChoices), function(choice, cIdx) {
    return _c('div', {
      staticClass: "col-4 col-sm-4 col-md-4 py-1 px-1"
    }, [_c('div', {
      staticClass: "donate-item py-2 px-1 py-md-3 h-100 text-center radius",
      class: [_vm.donorItemClasses, {
        'active': !_vm.isCustomAmount && (_vm.amount === choice && _vm.amount > 0)
      }],
      on: {
        "click": function($event) {
          return _vm.setAmount(choice)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex h-100 align-items-center flex-wrap justify-content-center"
    }, [_c('label', {
      staticClass: "m-0 w-100"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.amount),
        expression: "amount",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "radio",
        "name": "amount"
      },
      domProps: {
        "value": choice,
        "checked": _vm._q(_vm.amount, _vm._n(choice))
      },
      on: {
        "input": _vm.onAmountChange,
        "click": _vm.onAmountChange,
        "change": function($event) {
          _vm.amount = _vm._n(choice)
        }
      }
    }), _vm._v(" " + _vm._s(_vm._f("comma")(choice)) + " บาท\n          ")]), _vm._v(" "), (_vm.choiceDescriptions[cIdx]) ? _c('div', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.choiceDescriptions[cIdx]))]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 px-1"
  }, [_c('div', {
    staticClass: "donate-item--other pt-2 pt-md-3 text-left radius h-100",
    class: [_vm.donorItemClasses, {
      'active': _vm.isCustomAmount
    }],
    on: {
      "click": function($event) {
        _vm.isCustomAmount = true;
        _vm.$refs.inputCustomAmount.focus()
      }
    }
  }, [_c('div', {
    staticClass: "d-flex h-100 align-items-center flex-column justify-content-between item-other"
  }, [_c('label', {
    staticClass: "other-item d-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCustomAmount),
      expression: "isCustomAmount"
    }],
    attrs: {
      "name": "amount",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isCustomAmount, true)
    },
    on: {
      "change": function($event) {
        _vm.isCustomAmount = true
      }
    }
  }), _vm._v(" ระบุจำนวน\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.customAmount),
      expression: "customAmount",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputCustomAmount",
    staticClass: "form__text form__text--line text-left",
    attrs: {
      "type": "number",
      "autocomplete": "off",
      "placeholder": "ระบุจำนวน",
      "onkeydown": "if(event.key==='.'){event.preventDefault();}",
      "oninput": "event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
    },
    domProps: {
      "value": (_vm.customAmount)
    },
    on: {
      "focus": function($event) {
        _vm.isCustomAmount = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customAmount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "prefix"
  }, [_vm._v("บาท")])])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['customAmount'].minimum),
      expression: "$v.$errors['customAmount'].minimum"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("\n    จำนวนเงินขั้นต่ำ " + _vm._s(_vm.product.originalPrice) + " บาท\n  ")]), _vm._v(" "), _c('product-duration', {
    attrs: {
      "product": _vm.product,
      "donate-type": _vm.effectiveDonateType,
      "value": _vm.totalCount
    },
    on: {
      "input": _vm.onTotalCountChange
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-281b39f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-281b39f4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDonateChoice.vue
// module id = 733
// module chunks = 1